import { useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { AffiliationInitial } from "../pages";
import { HomeLayout } from "../template";
import { PersonalDataForm, StepNav, CommerceDataForm, FileDataForm, CostDataForm, CicacForm, SignatureForm, SuccessForm } from "../components";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'leaflet/dist/leaflet.css'
import Login from "../pages/initial";
import { properties } from "../utils/Properties_es";


const stepsNav = [
    { key: "personal", label: properties.step_personal, path: "forms/personal" },
    { key: "commerce", label: properties.step_commerce, path: "forms/commerce" },
    { key: "files", label: properties.step_files, path: "forms/files" },
    { key: "costs", label: properties.step_costs, path: "forms/costs" }
]


function App() {
    const [completedSteps, setCompletedSteps] = useState({
        personal: false,
        commerce: false,
        files: false,
        costs: false,
        cicac: false,
        signature: false
    });
    const [formData, setFormData] = useState({
        personal: {},
        commerce: {},
        files: {},
        costs: {},
        cicac: {},
        signature: {}
    });
    const updateFormSection = (section,data) =>{
        setFormData(prev=> ({
            ...prev,
            [section]: {...prev[section], ...data}
        }))
    }

    return (
    <Routes>
        {/* RUTA PADRE: Todo lo que esté aquí adentro usará HomeLayout y su validación */}
        <Route element={<HomeLayout />}>
            
            {/* 1. Login y rutas de entrada (Ahora protegidas por el Layout) */}
            <Route path="/portal-web/:id?" element={<Login updateData={(data) => updateFormSection("personal", data)} />} />
            
            {/* 2. Rutas de formularios */}
            <Route path="/forms/:id">
                <Route path="personal" element={
                    <>
                        <StepNav steps={stepsNav} activeKey="personal" completedSteps={completedSteps} />
                        <PersonalDataForm 
                            onValidate={(isValid) => setCompletedSteps(prev => ({ ...prev, personal: isValid }))}
                            data={formData.personal}
                            updateData={(data) => updateFormSection("personal", data)} 
                        />
                    </>
                } />

                <Route path="commerce" element={
                    <>
                        <StepNav steps={stepsNav} activeKey="commerce" completedSteps={completedSteps} />
                        <CommerceDataForm 
                            onValidate={(isValid) => setCompletedSteps(prev => ({ ...prev, commerce: isValid }))}
                            data={formData.commerce}
                            updateData={(data) => updateFormSection("commerce", data)} 
                        />
                    </>
                } />

                <Route path="files" element={
                    <>
                        <StepNav steps={stepsNav} activeKey="files" completedSteps={completedSteps} />
                        <FileDataForm 
                            onValidate={(isValid) => setCompletedSteps(prev => ({ ...prev, files: isValid }))}
                            data={formData.files}
                            updateData={(data) => updateFormSection("files", data)} 
                        />
                    </>
                } />

                <Route path="costs" element={
                    <>
                        <StepNav steps={stepsNav} activeKey="costs" completedSteps={completedSteps} />
                        <CostDataForm 
                            onValidate={(isValid) => setCompletedSteps(prev => ({ ...prev, costs: isValid }))}
                            data={formData.costs}
                            updateData={(data) => updateFormSection("costs", data)} 
                            finalData={formData}
                        />
                    </>
                } />

                <Route path="cicac" element={<CicacForm 
                    onValidate={(isValid) => setCompletedSteps(prev => ({ ...prev, cicac: isValid }))}
                    data={formData.cicac}
                    updateData={(data) => updateFormSection("cicac", data)} 
                />} />

               {/*  <Route path="signature" element={<SignatureForm 
                    onValidate={(isValid) => setCompletedSteps(prev => ({ ...prev, signature: isValid }))}
                    data={formData.signature}
                    updateData={(data) => updateFormSection("signature", data)} 
                />} /> */}

                <Route path="success" element={<SuccessForm data={formData}/>} />
            </Route>
            <Route path="/:id?" element={<Login updateData={(data) => updateFormSection("personal", data)} />} />
            
        </Route>

        
        <Route path="/initial/:id?" element={<AffiliationInitial/>} />
        
        {/* Manejo de ruta raíz sin ID */}
        <Route path="/" element={<div className="p-5 text-center">Por favor, proporcione un ID de transacción válido.</div>} />
        
        {/* Captura de rutas no encontradas */}
        <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
);

}

export default App;